import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './ASESElbow.scss';

const ASESElbow = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">ASES</h2>      
      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion1', fieldErrors, touchedFields, values.ases.asesQuestion1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              1. Heeft u pijn in uw elleboog?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion1"
              required
              value={values.ases.asesQuestion1}
              onChange={(event) => handleFormData("ases", "asesQuestion1", event.target.value)}
              aria-label="Pijn in elleboog"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion2', fieldErrors, touchedFields, values.ases.asesQuestion2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              2. Beoordeel uw pijn: Wanneer het op zijn ergst is
            </label>
            <p className="modern-form-help">
              Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion2"
                required
                value={values.ases.asesQuestion2 || ''}
                min="0"
                max="10"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion2", event.target.value)}
                aria-label="Pijn op zijn ergst"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion2"
                required
                min="0"
                max="10"
                step="1"
                value={values.ases.asesQuestion2 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion2", event.target.value.trim())}
                aria-label="Pijnwaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion3', fieldErrors, touchedFields, values.ases.asesQuestion3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              3. Beoordeel uw pijn: In ruststand
            </label>
            <p className="modern-form-help">
              Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion3"
                required
                value={values.ases.asesQuestion3 || ''}
                min="0"
                max="10"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion3", event.target.value)}
                aria-label="Pijn in ruststand"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion3"
                required
                min="0"
                max="10"
                step="1"
                value={values.ases.asesQuestion3 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion3", event.target.value.trim())}
                aria-label="Pijnwaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion4', fieldErrors, touchedFields, values.ases.asesQuestion4);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              4. Beoordeel uw pijn: Bij het tillen van een zwaar voorwerp
            </label>
            <p className="modern-form-help">
              Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion4"
                required
                value={values.ases.asesQuestion4 || ''}
                min="0"
                max="10"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion4", event.target.value)}
                aria-label="Pijn bij tillen zwaar voorwerp"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion4"
                required
                min="0"
                max="10"
                step="1"
                value={values.ases.asesQuestion4 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion4", event.target.value.trim())}
                aria-label="Pijnwaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion5', fieldErrors, touchedFields, values.ases.asesQuestion5);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              5. Beoordeel uw pijn: Bij het doen van een taak met herhaalde elleboogbewegingen
            </label>
            <p className="modern-form-help">
              Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion5"
                required
                value={values.ases.asesQuestion5 || ''}
                min="0"
                max="10"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion5", event.target.value)}
                aria-label="Pijn bij herhaalde elleboogbewegingen"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion5"
                required
                min="0"
                max="10"
                step="1"
                value={values.ases.asesQuestion5 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion5", event.target.value.trim())}
                aria-label="Pijnwaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion6', fieldErrors, touchedFields, values.ases.asesQuestion6);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              6. Beoordeel uw pijn: 's Nachts
            </label>
            <p className="modern-form-help">
              Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion6"
                required
                value={values.ases.asesQuestion6 || ''}
                min="0"
                max="10"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion6", event.target.value)}
                aria-label="Pijn 's nachts"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion6"
                required
                min="0"
                max="10"
                step="1"
                value={values.ases.asesQuestion6 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion6", event.target.value.trim())}
                aria-label="Pijnwaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      <h3 className="assessment-subtitle">Kies het antwoord dat uw huidige status het best beschrijft bij het doen van de volgende activiteiten:</h3>      

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion7', fieldErrors, touchedFields, values.ases.asesQuestion7);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">7. Bovenste knoop van overhemd openen/sluiten</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion7"
              required
              value={values.ases.asesQuestion7}
              onChange={(event) => handleFormData("ases", "asesQuestion7", event.target.value)}
              aria-label="Bovenste knoop van overhemd openen/sluiten"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion8', fieldErrors, touchedFields, values.ases.asesQuestion8);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">8. Gebruik van toilet</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion8"
              required
              value={values.ases.asesQuestion8}
              onChange={(event) => handleFormData("ases", "asesQuestion8", event.target.value)}
              aria-label="Gebruik van toilet"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion9', fieldErrors, touchedFields, values.ases.asesQuestion9);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">9. Haar kammen</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion9"
              required
              value={values.ases.asesQuestion9}
              onChange={(event) => handleFormData("ases", "asesQuestion9", event.target.value)}
              aria-label="Haar kammen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion10', fieldErrors, touchedFields, values.ases.asesQuestion10);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">10. Schoenveters strikken</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion10"
              required
              value={values.ases.asesQuestion10}
              onChange={(event) => handleFormData("ases", "asesQuestion10", event.target.value)}
              aria-label="Schoenveters strikken"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion11', fieldErrors, touchedFields, values.ases.asesQuestion11);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">11. Eten met bestek</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion11"
              required
              value={values.ases.asesQuestion11}
              onChange={(event) => handleFormData("ases", "asesQuestion11", event.target.value)}
              aria-label="Eten met bestek"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion12', fieldErrors, touchedFields, values.ases.asesQuestion12);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">12. Een zwaar voorwerp dragen</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion12"
              required
              value={values.ases.asesQuestion12}
              onChange={(event) => handleFormData("ases", "asesQuestion12", event.target.value)}
              aria-label="Een zwaar voorwerp dragen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion13', fieldErrors, touchedFields, values.ases.asesQuestion13);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">13. Uit stoel opstaan met hulp van arm</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion13"
              required
              value={values.ases.asesQuestion13}
              onChange={(event) => handleFormData("ases", "asesQuestion13", event.target.value)}
              aria-label="Uit stoel opstaan met hulp van arm"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion14', fieldErrors, touchedFields, values.ases.asesQuestion14);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">14. Zware huishoudelijke taken uitvoeren</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion14"
              required
              value={values.ases.asesQuestion14}
              onChange={(event) => handleFormData("ases", "asesQuestion14", event.target.value)}
              aria-label="Zware huishoudelijke taken uitvoeren"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion15', fieldErrors, touchedFields, values.ases.asesQuestion15);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">15. Een sleutel omdraaien</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion15"
              required
              value={values.ases.asesQuestion15}
              onChange={(event) => handleFormData("ases", "asesQuestion15", event.target.value)}
              aria-label="Een sleutel omdraaien"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion16', fieldErrors, touchedFields, values.ases.asesQuestion16);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">16. Een bal gooien</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion16"
              required
              value={values.ases.asesQuestion16}
              onChange={(event) => handleFormData("ases", "asesQuestion16", event.target.value)}
              aria-label="Een bal gooien"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion17', fieldErrors, touchedFields, values.ases.asesQuestion17);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">17. Gebruikelijke werkzaamheden uitvoeren</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion17"
              required
              value={values.ases.asesQuestion17}
              onChange={(event) => handleFormData("ases", "asesQuestion17", event.target.value)}
              aria-label="Gebruikelijke werkzaamheden uitvoeren"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion18', fieldErrors, touchedFields, values.ases.asesQuestion18);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">18. Gebruikelijke sport beoefenen</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion18"
              required
              value={values.ases.asesQuestion18}
              onChange={(event) => handleFormData("ases", "asesQuestion18", event.target.value)}
              aria-label="Gebruikelijke sport beoefenen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Niet in staat om te doen">Niet in staat om te doen</option>
              <option value="Zeer moeilijk te doen">Zeer moeilijk te doen</option>
              <option value="Enigszins moeilijk">Enigszins moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default ASESElbow;
